import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-modal-text-input',
  templateUrl: './modal-text-input.component.html',
  styleUrls: ['./modal-text-input.component.scss']
})
export class ModalTextInputComponent implements OnInit {
  public title: any;
  constructor(public dialogRef: MatDialogRef<ModalTextInputComponent>, @Inject(MAT_DIALOG_DATA) public data: any) { }

  ngOnInit(): void {
    this.title = this.data.title
  }

  setValue(elem) {
    console.log(elem.value)
    this.dialogRef.close(elem.value)
  }

}
